module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAS5JREFUOE/t1L8rRnEUx/HXI/mRFAZZyWQxm6X8GJQMlmdQGJRSZDBQBjFgRhmYlKSUIoNB+QdMYrYwIhL66nvrdnseDzI6dbt17znv7zmf87k3548iV4LThB2EvDxui+V/BerFFo5jcTdGcFgIVghUhWUMYwqbsTBAVrGNGTymgVlQG/bwgCHcZE5vwS5qMYjL5H0aNIl5rGARb0X0KMMsprEQu/wUMcQJuvCEa9SUWELouBXVOA21CagDlb90wjMushqVx5HSY1XgJXNIGC9cr4U0Cs/247rXY0IQNwhal4GNoR99xUAHOMJGTGjGVdQs3dUoBtDzD/JjjerRiDWcx+0FazTgDO14j8KGexC6E+O4w33io4n4aSTJaX8FTwXPpCOdN4elUv+jb5v9A1gBShPvfTMPAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/Ji.png
// module id = seqe
// module chunks = 7